<script lang="ts" setup>
import { ref } from 'vue';
import { IPrinter, GetManyResult, PrinterType } from '@posx/core';
import { usePrinterStore } from '@/stores/printer';
import { logError, serializeError } from '@/utils/logger';

const $props = defineProps<{
  modelValue?: string | string[];
  multiple?: boolean;
  type?: PrinterType;
  rootFormData?: any;
  showNotPrint?: boolean;
}>();
const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);

const printerStore = usePrinterStore();
const list = ref<IPrinter[]>([]);

printerStore
  .getMany({
    type: $props.type,
  })
  .then((data: GetManyResult<IPrinter> | undefined) => {
    if (data) {
      list.value = data.list;
    }
  }).catch((err) => logError('Failed to fetch printers', serializeError(err)));

const value = ref($props.modelValue);
const handleChange = () => {
  if ($props.rootFormData) {
    $props.rootFormData.print_template_uid = '';
  }
  $emit('change', value.value);
  $emit('update:value', value.value);
  $emit('update:modelValue', value.value);
};
</script>

<template>
  <el-select v-model="value" @change="handleChange" :multiple="$props.multiple" collapse-tags>
    <el-option v-if="showNotPrint" key="not_print" label="Not Print" value="not_print"></el-option>
    <el-option v-for="item in list" :key="item.uid" :label="item.name" :value="item.uid"></el-option>
  </el-select>
</template>
